/**
 * Resolución de la tienda pública por SUBDOMINIO en producción.
 *
 *   app.tuplazita.com        → modo ADMIN (panel)
 *   {slug}.tuplazita.com     → modo TIENDA (catálogo público del tenant {slug})
 *   localhost / otros        → modo ADMIN; la tienda se prueba por ruta /tienda/:slug
 *
 * En producción el dominio se fija a 'tuplazita.com' (igual que axios.ts fija la API).
 * En local queda vacío, así el host localhost nunca se interpreta como tienda.
 */
export const STORE_DOMAIN =
  process.env.NODE_ENV === 'production'
    ? 'tuplazita.com'
    : (process.env.REACT_APP_STORE_DOMAIN || '');

// Subdominios que NO son tiendas
const RESERVED = ['app', 'www', 'api', 'admin'];

/** Devuelve el slug si el host actual es una tienda por subdominio; si no, null. */
export function getStoreSlugFromHost(): string | null {
  if (!STORE_DOMAIN) return null;
  const host = window.location.hostname;
  if (host === STORE_DOMAIN) return null;            // apex no es tienda
  const suffix = '.' + STORE_DOMAIN;
  if (!host.endsWith(suffix)) return null;           // otro dominio (ej. mana.ibctrujillo.com)
  const label = host.slice(0, host.length - suffix.length);
  if (!label || label.includes('.') || RESERVED.includes(label)) return null;
  return label;
}

/** ¿El host actual es una tienda pública por subdominio? */
export function isStoreHost(): boolean {
  return getStoreSlugFromHost() !== null;
}

/** ¿El host actual es el apex (tuplazita.com / www) → directorio central? */
export function isDirectoryHost(): boolean {
  if (!STORE_DOMAIN) return false;
  const host = window.location.hostname;
  return host === STORE_DOMAIN || host === 'www.' + STORE_DOMAIN;
}

/** Construye el enlace público de una tienda (subdominio en prod, ruta en local). */
export function buildStoreUrl(slug: string): string {
  const host = window.location.hostname;
  if (STORE_DOMAIN && host !== 'localhost' && host !== '127.0.0.1') {
    return `https://${slug}.${STORE_DOMAIN}`;
  }
  return `${window.location.origin}/tienda/${slug}`;
}
